<template>
    <div></div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    data() {},
    methods: {
        ...mapActions(['fetchUser']),
    },
    created() {
        if (this.$store.state.isUserLogged) {
            this.fetchUser().then(data => {
                let userData = {
                    email: data.email,
                    id: data.id,
                    first_name: data.firstName,
                    last_name: data.lastName,
                    account_type: data.productLine.label === 'PRO_BASIC' ? 'pro' : 'consumer',
                };
                window.parent.postMessage(userData, '*');
            });
        } else {
            let userData = {
                email: null,
            };
            window.parent.postMessage(userData, '*');
        }
    },
};
</script>
<style>
#app {
    display: none;
}
</style>



// WEBPACK FOOTER //
// login-oauth.vue?71ddec23